import React from "react";

import Oranguhang from "./Oranguhang";
import PelvisNodes from "./PelvisNodes";
import RollingBridge from "./RollingBridge";

import "./Animation.css";

class Animation extends React.Component {

	constructor(props) {
		super(props);
		this.readyState = false;
		this.views = {
			"/teams": {
				content: <PelvisNodes 
					onAnimationEnd={this.props.onAnimationEnd} 
					onRef={ref => this.content = ref} 
					setReadyState={this.handleReadyState.bind(this)} />,
				selector: "PelvisNodes",
			},
			"/thc/about": {
				content: <Oranguhang 
					onAnimationEnd={this.props.onAnimationEnd} 
					onRef={ref => this.content = ref} 
					setReadyState={this.handleReadyState.bind(this)} />,
				selector: "Oranguhang",
			},
			"/thc/updates": {
				content: <RollingBridge 
					onAnimationEnd={this.props.onAnimationEnd} 
					onRef={ref => this.content = ref} 
					setReadyState={this.handleReadyState.bind(this)} />,
				selector: "RollingBridge",
			},
		}
	}

	componentDidMount() {
		// Allows to assign this to an attr in parent
		this.props.onRef(this);
	}

	handleReadyState(readyState) {
		this.readyState = readyState;
	}

	animate() {
		// Debounce by 100 ms if SVG not ready
		if (this.readyState===false) {
			setTimeout(() => this.animate(), 100);
		} else {
			// animate the appropriate component
			this.content.animate();
		}
	}

	renderAnimation() {
		var content = this.views[this.props.view.path] ? this.views[this.props.view.path].content : null;
		return content;
	}

	render() {
		return (
			<div id="Animation-wrapper">
				{this.renderAnimation()}
			</div>
		);
	}
}

export default Animation;


// WEBPACK FOOTER //
// ./src/animation/Animation.js